import React, { useState } from "react";
import { FiPhoneCall, FiCopy, FiCheck } from "react-icons/fi";
import { toast } from "react-toastify";
import "./index.css";

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback for http:// pages / older browsers.
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
};

/**
 * 📞 9441864651 ⧉  — tap the number to call, tap the icon to copy.
 * Clicks don't bubble, so it's safe inside clickable table rows.
 * `children` lets a caller render highlighted text for the number.
 */
const PhoneCell = ({ number, children }) => {
  const [copied, setCopied] = useState(false);
  const value = number == null ? "" : String(number).trim();
  if (!value) return <span className="phone-cell__none">—</span>;

  const onCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (await copyText(value)) {
      setCopied(true);
      toast.success("Phone number copied", { autoClose: 1200 });
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <span className="phone-cell">
      <a
        href={`tel:${value}`}
        className="phone-cell__call"
        onClick={(e) => e.stopPropagation()}
        title={`Call ${value}`}
      >
        <FiPhoneCall aria-hidden="true" />
        <span>{children || value}</span>
      </a>
      <button
        type="button"
        className={`phone-cell__copy ${copied ? "is-copied" : ""}`}
        onClick={onCopy}
        aria-label={`Copy ${value}`}
        title="Copy number"
      >
        {copied ? <FiCheck /> : <FiCopy />}
      </button>
    </span>
  );
};

export default PhoneCell;
